export default __webpack_public_path__ + "static/media/smallbanners_Motilal-Oswal-Midcap-Fund.5e2c7162.jpg";